import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Client } from '../shared/client/client';
import { ClientService } from '../shared/client/client.service';
import { BordereauxService } from './shared/bordereaux.service';
import { MatDialog } from '@angular/material/dialog';
import { DownloadDialogComponent } from './download-dialog/download-dialog.component';

@Component({
  selector: 'app-bordereaux',
  templateUrl: './bordereaux.component.html',
  styleUrls: ['./bordereaux.component.scss']
})
export class BordereauxComponent implements OnInit, OnDestroy {

  sub: Subscription = new Subscription()
  subDelay: Subscription = new Subscription()
  subClient: Subscription
  currentClient: Client
  bordereaux
  download = false;
  delay;

  constructor(
    protected clientService: ClientService,
    protected bordereauxService: BordereauxService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      this.loadData(this.currentClient)
      this.getDelayBordereaux()
    })
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe()
    this.subDelay.unsubscribe()
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  private loadData(client) {
    this.sub.unsubscribe()
    this.sub = this.bordereauxService.getBordereaux(client).subscribe(data => {
      this.bordereaux = data
    })
  }

  export(data) {
    const dialogRef = this.dialog.open(DownloadDialogComponent, { data: data });
    dialogRef.afterClosed().subscribe(result => {
      this.download = true
      this.sub = this.bordereauxService.downloadBordereaux(data, !result).subscribe(data => {
        this.download = false
      });
    }, err => console.log(err), () => {
      this.download = false
    });
  }

  getDelayBordereaux() {
    this.subDelay = this.bordereauxService.getDelayBordereaux().subscribe(data => {
      this.delay = data
    });
  }
}
